import { apiBaseUrl } from 'app/src/msw/companyagreement/api/apiBaseUrl'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

export const getApiConfiguration = http.get<object, DefaultBodyType, companyagreementApi.ApiConfiguration>(
  apiBaseUrl + '/',
  async () => {
    const jsonData = await (await fetch('data/companyagreement/apiConfiguration/apiConfiguration.json')).json()

    return HttpResponse.json(jsonData)
  },
)
